import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import styles from "./PatientStatusBadge.module.scss";

const BADGE_CONFIG = [
  { key: "doNotEmail", icon: "envelope", label: "Do Not Email" },
  { key: "isFired", icon: "user", label: "Fired Patient" },
  { key: "doNotCall", icon: "phone", label: "Do Not Call" },
  { key: "doNotSms", icon: "mobile", label: "Do Not SMS" },
];

export function PatientStatusBadge({
  patientId,
  doNotEmail,
  doNotCall,
  doNotSms,
  isFired,
}) {
  const statusValues = { doNotEmail, isFired, doNotCall, doNotSms };
  const hasAnyStatus = Object.values(statusValues).some(Boolean);

  if (!hasAnyStatus) {
    return null;
  }

  return (
    <span className={styles.container}>
      {BADGE_CONFIG.map(({ key, icon, label }) => {
        if (!statusValues[key]) return null;

        const badgeId = `${key}-${patientId}`;

        return (
          <React.Fragment key={key}>
            <span className={styles.badge} data-tip data-for={badgeId}>
              <span className="fa-stack">
                <i className={`fa fa-${icon} fa-stack-1x`} />
                <i className="fa fa-ban fa-stack-2x" />
              </span>
            </span>
            <ReactTooltip
              id={badgeId}
              place="top"
              effect="solid"
              className={styles.tooltip}
            >
              {label}
            </ReactTooltip>
          </React.Fragment>
        );
      })}
    </span>
  );
}

PatientStatusBadge.propTypes = {
  patientId: PropTypes.number.isRequired,
  doNotEmail: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  doNotCall: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  doNotSms: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  isFired: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

PatientStatusBadge.defaultProps = {
  doNotEmail: false,
  doNotCall: false,
  doNotSms: false,
  isFired: false,
};
